/*
 * preview.js  –  TinyMeTales プレビュー生成フロー
 * -------------------------------------------------
 * 1. ユーザーが写真を選択          → S3 に直接アップロード
 * 2. 「プレビュー」ボタンをクリック → Lambda(/apps/tinyme-generate-preview) へキーを送信
 * 3. 生成中は loading-spinner を表示
 * 4. 返ってきた preview_url を <img> に差し込み表示
 * 5. job_id を cart line-item properties に仕込む
 */

(() => {
  /** DOM 取得 **/
  const fileInput  = document.getElementById('photo-upload');
  const previewBtn = document.getElementById('preview-btn');
  const loader     = document.getElementById('preview-loader');
  const previewImg = document.getElementById('preview-img');

  /** ステート **/
  let s3Key = null;   // S3 に置いたアップロード画像のキー
  let jobId = null;   // プレビュー生成ジョブ ID

  /* ------------------------------------------------
   * ① ファイル選択 → S3 アップロード
   * ---------------------------------------------- */
  fileInput.addEventListener('change', async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      /* presign URL 取得（API Gateway → tinyme-presign Lambda） */
      const presignRes = await fetch('/apps/tinyme-presign', {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ filename: file.name, content_type: file.type })
      });
      if (!presignRes.ok) throw new Error('アップロード情報の取得に失敗しました');

      const { url, fields, key } = await presignRes.json();

      /* S3 へ直接 POST */
      const form = new FormData();
      Object.entries(fields).forEach(([k, v]) => form.append(k, v));
      form.append('file', file);

      const uploadRes = await fetch(url, { method: 'POST', body: form });
      if (!uploadRes.ok) throw new Error('画像のアップロードに失敗しました');

      s3Key = key;               // 成功したので保持
      previewBtn.disabled = false;
    } catch (err) {
      alert(err.message || 'アップロード中にエラーが発生しました');
      console.error(err);
    }
  });

  /* ------------------------------------------------
   * ② プレビュー生成を実行
   * ---------------------------------------------- */
  previewBtn.addEventListener('click', async () => {
    if (!s3Key) return;

    /* ローダーを表示 */
    loader.classList.remove('hidden');
    previewBtn.disabled = true;

    try {
      const genRes = await fetch('/apps/tinyme-generate-preview', {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ key: s3Key })
      });
      if (!genRes.ok) throw new Error('イラスト生成に失敗しました');

      const { preview_url, job_id } = await genRes.json();
      jobId = job_id;

      /* 画像を表示 */
      previewImg.src = preview_url;
      previewImg.classList.remove('hidden');

      /* ★ Pixel に PreviewGenerated を送信 */
      if (window.fbq) {
        fbq('trackCustom', 'PreviewGenerated', {
          job_id: jobId,
          content_name: 'TinyMeTales cover preview',
          value: 0,
          currency: 'JPY'
        });
      }

      /* カートフォームに hidden input を追加（1 度だけ） */
      const cartForm = document.querySelector('form[action^="/cart/add"]');
      if (cartForm && !cartForm.querySelector('input[name="properties[_preview_job_id]"]')) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type  = 'hidden';
        hiddenInput.name  = 'properties[_preview_job_id]';
        hiddenInput.value = jobId;
        cartForm.appendChild(hiddenInput);
      }
    } catch (err) {
      alert(err.message || '生成処理でエラーが発生しました');
      console.error(err);
    } finally {
      /* ローダーを隠す */
      loader.classList.add('hidden');
      previewBtn.disabled = false;
    }
  });
})();
